import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { TournamentsService } from './../tournaments/services/tournaments.service';
declare let $;
declare let SetLanguage: any;
@Component({
    selector: 'comp_live_cashout_modal',
    templateUrl: './live_cashout_modal.html',
})
export class LiveCashoutModal implements OnInit {
    constructor(public tournamentsService: TournamentsService) {}

    @Output('systemSlip_ChangeAmount') systemSlipChangeAmount = new EventEmitter();
    init: boolean;
    ngOnInit() {
        if (this.init) return;
        this.init = true;
    }
}
